module.exports = __webpack_public_path__ + "static/media/main-bg.f23ce00a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/main-bg.jpg
// module id = 124
// module chunks = 0